import { MarkdownActionsProvider } from "@/components/assistant-ui/markdown-actions";
import { PropsWithChildren, useCallback, useMemo } from "react";
import { useDocumentViewer } from "../contexts/useDocumentViewer";

export const MarkdownActionsBridge = ({ children }: PropsWithChildren) => {
    const { openDocumentById } = useDocumentViewer();

    const onNavigate = useCallback((target: string) => {
        window.open(`/organizations/${target}`, "_blank");
    }, []);

    const onSource = useCallback(
        (documentId: number, page?: number) => {
            openDocumentById(documentId, page);
        },
        [openDocumentById]
    );

    const actions = useMemo(
        () => ({ onNavigate, onSource }),
        [onNavigate, onSource]
    );

    return (
        <MarkdownActionsProvider value={actions}>
            {children}
        </MarkdownActionsProvider>
    );
};
